!(function($) {
  window.diamondCalculator = {
    calculatorForm : $('#calculator'),
    inputCarat     : $('input[name="carat"]'),
    inputRange     : $('input[type="range"]'),
    activeLabel    : $('.segmented-control label'),
    messageBox     : $('#pricing-message'),
  
    /**
     * @summary Initializes the diamond calculator
     * 
     * @return  {void}
     */
    init: function() {
      var self = this;
  
      self.addEventListeners();
      self.displayResults();
    },
    
    /**
     * @summary Adds the various event listeners
     * 
     * @return  {void}
     */
    addEventListeners: function() {
      var self = this;
  
      self.inputCarat.on('input change', function() {
        $(this).siblings("output").val($(this).val());
        self.displayResults();
      });
  
      // Toggle Active Label
      self.activeLabel.on('click', function() {
        $(this).addClass('active').siblings("label").removeClass('active');
        self.displayResults();
      });
    },

    /**
     * @summary Updates the dom
     * 
     * @return  {void}
     */
    displayResults: function() {
      var self     = this;
      setTimeout(function() {
        var formData = self.calculatorForm.serializeArray();
  
        if( window.diamondData !== undefined && formData.length === 4) {
          var valueMapping = window.diamondData[formData[0].value][formData[1].value][formData[2].value][formData[3].value]
  
          self.messageBox.text( '$' + valueMapping.low_price + ' - ' + '$' + valueMapping.high_price );
        }
      }, 200);
    }
  }
  
  $(document).ready(function () {
    window.diamondCalculator.init();
  });
}(jQuery));
